<template>
	<div>
		<v-alert v-if="localOrStage"
						 border="top"
						 colored-border
						 type="warning"
						 elevation="4"
		>
			Die Stage Umgebung ist <b>nicht</b> mit der richtigen Ad Control verbunden, ihr könnt also nichts kaputt
			machen.
			<br>
			Bei den Daten handelt es sich um eine Kopie vom 30.08.2021.
		</v-alert>
		<h2 class="text-lg-h5 font-weight-bold">Verwaltung Display<span
			v-if="selectedSite">: {{ selectedSite.Name }}{{ selectedType ? ' - ' + selectedType.Name : '' }}
        </span>
		</h2>
		<v-img
			v-if="siteDetails && siteDetails.Site.UsesAdaBundle === 1 && !$store.state.display.loadingSite"
			class="adaBundle"
			src="../../assets/adabundle_stamp.png"></v-img>
		<!-- DEVICE TYPE SWITCHES -->
		<v-row no-gutters>
			<v-switch
				v-model="device_types"
				label="App"
				:color="ada.blue"
				value="app"
				class="mr-6"
			></v-switch>
			<v-switch
				v-model="device_types"
				label="Mobile"
				:color="ada.blue"
				value="mobile"
				class="mr-6"
			></v-switch>
			<v-switch
				v-model="device_types"
				label="Desktop"
				:color="ada.blue"
				value="desktop"
			></v-switch>
		</v-row>

		<!-- PUBLISHER SELECT -->
		<PublisherSelect></PublisherSelect>
		<div class="d-flex flex-row">
			<!-- SITES SELECT -->
			<SiteSelect v-model="selectedSite" @beforeChange="beforeSiteChange"
									:beforeChangeEvent="true" style="width:400px" :showStatus="true">
				<TooltipIcon
					v-if="!$vuetify.breakpoint.smAndDown"
					:custom-style="{marginLeft:'10px'}"
					:color="ada.darkGrey"
					:fab="true"
					:xsmall="true" @click="toggleSitesList"
					:tooltip="'Seitenliste '+ (showSitesList ? 'ausblenden' : 'einblenden')">
					mdi-format-list-bulleted
				</TooltipIcon>
			</SiteSelect>

			<!-- SITETYPE SELECT -->
			<SitetypeSelect v-model="selectedType" @beforeChange="beforeSitetypeChange"
											:beforeChangeEvent="true" style="width:400px">
			</SitetypeSelect>
		</div>
		<SiteStatus @intervalStart="siteStatusInterval = $event" store="display"
								:currentIntervalId="siteStatusInterval" :startIntervalEvent="startSiteInterval"></SiteStatus>
		<v-row v-if="selectedSite && siteDetails" no-gutters>
			<v-col style="padding:0;">
				<v-alert
					:value="selectedSite && siteDetails && siteDetails.Current.BlockerEnabled === 1"
					:color="ada.red"
					dark
					dense
					class="mb-5"
					border="top"
					icon="mdi-alert-octagon-outline"
					transition="scale-transition"
				>
					<div>{{ blockerMessage }}</div>
				</v-alert>
			</v-col>
		</v-row>
		<!-- SITE DETAILS -->
		<v-row no-gutters style="position:relative">
			<v-col :cols="showSitesList ? 3 : 0" v-if="!$vuetify.breakpoint.smAndDown">
				<SitesList v-model="selectedSite" :show="showSitesList" class="mr-4"
									 :style="{maxHeight: detailsRowHeight+'px', height:detailsRowHeight+'px'}"
									 :key="detailsRowHeight"></SitesList>
			</v-col>
			<v-col :cols="showSitesList && !$vuetify.breakpoint.smAndDown ? 9 : 12">
				<v-tabs class="borderTopRadius" v-model="tab" :color="ada.blue" show-arrows
								:key="showSitesList" ref="tabHeader">
					<v-tabs-slider :color="ada.blue"></v-tabs-slider>
					<v-tab flat v-for="tab in tabs" :key="tab.name">
						<v-badge v-if="tab.component === 'Notes' && hasNote"
										 :color="ada.pink"
										 dot
						>
							{{ tab.name }}
						</v-badge>
						<span v-else>{{ tab.name }}</span>
					</v-tab>
				</v-tabs>
				<v-tabs-items v-model="tab" ref="tabContent" class="borderBottomRadius">
					<v-tab-item
						v-for="tab in tabs"
						:key="tab.name"
					>
						<v-card flat>
							<v-card-text style="min-height: 20vh;">
								<transition name="fade" mode="out-in">
									<component :is="tab.component" @submit="handleValidation"
														 :readOnly="readOnly"
														 @change="handleChange"
														 @snackbar="activateSnackbar"
														 @deploy:preview="deployPreview"
														 @deploy:live="openDeployDialog"
														 v-if="!vuexState.loadingSite"
														 @activeComponent="updateActiveComponent"
														 @error="hideDialogs"
									/>
								</transition>
							</v-card-text>
						</v-card>
					</v-tab-item>
				</v-tabs-items>
			</v-col>
		</v-row>
		<DeployLiveDialog v-model="showDeployLiveDialog" @submit="deployLive"></DeployLiveDialog>
		<SaveChangesDialog v-model="showSaveChangesDialog" @discard="triggerChildsInit"
											 @save="submit($event, true)"></SaveChangesDialog>

		<EditSiteDialog v-model="showEditSiteDialog"></EditSiteDialog>
		<CopySiteDialog v-model="showCopySiteDialog"></CopySiteDialog>
		<!--<Dialog v-model="apriljoke"
						:hide-cancel-button="true"
						title="Auflösung des Ad Alliance Display Bereichs"
						@ok="apriljoke = false" ok-text="Verstanden"
						persistent>
				<p>Liebe Kolleg:innen,</p>
				<p>wie in der E-Mail vom 01.04.2024 angekündigt, wird der Ad Alliance Display Bereich im Mai eingestellt und
						somit auch der Display Bereich dieses Tools. </p>
				<p>Wir bedauern diesen Prozess und bitten um Eurer Verständnis.</p>
				<p>- Euer Ad Control Team</p>
		</Dialog>-->
	</div>
</template>

<script>
import ada from '../../scss/ada_colors.scss';
import General from "./Tabs/General";
import AdServer from "./Tabs/AdServer";
import Zones from "./Tabs/Zones";
import LocalJs from "./Tabs/LocalJs";
import LocalCss from "./Tabs/LocalCss";
import Modules from "./Tabs/Modules";
import Domains from "./Tabs/Domains";
import History from "./Tabs/History";
import Notes from "./Tabs/Notes";
import Blocking from "./Tabs/Blocking";
import Includes from "./Tabs/Includes";
import Dropdown from "../../components/Inputs/Dropdown";
import Button from "../../components/buttons/Button";
import AddSiteDialog from "../Settings/Dialogs/AddSiteDialog";
import TooltipIcon from "../../components/TooltipIcon";
import AddSitetypeDialog from "./Dialogs/AddSitetypeDialog";
import EditSiteDialog from "../Settings/Dialogs/EditSiteDialog";
import CopySiteDialog from "../Settings/Dialogs/CopySiteDialog";
import SaveChangesDialog from "../components/SaveChangesDialog";
import Dialog from "../../components/Dialog";
import LogInDialog from "../LogInDialog";
import DeployLiveDialog from "./Dialogs/DeployLiveDialog";
import PublisherSelect from "../components/PublisherSelect";
import SiteSelect from "../components/SiteSelect";
import CopySitetypeDialog from "./Dialogs/CopySitetypeDialog";
import SitesList from "../components/SitesList";
import Vue from 'vue';
import SitetypeSelect from "../components/SitetypeSelect";
import SiteStatus from "../components/SiteStatus";
import TooltipButton from "../../components/buttons/TooltipButton";
import AdTagRendering from "./Tabs/AdTagRendering";

export default {
	name: 'Display',
	components: {
		AdTagRendering,
		TooltipButton,
		SiteStatus,
		SitetypeSelect,
		SitesList,
		CopySitetypeDialog,
		SiteSelect,
		PublisherSelect,
		DeployLiveDialog,
		LogInDialog,
		Dialog,
		SaveChangesDialog,
		CopySiteDialog,
		EditSiteDialog,
		AddSitetypeDialog,
		TooltipIcon,
		AddSiteDialog,
		Button,
		Dropdown,
		Includes, Blocking, Notes, History, Domains, Modules, LocalCss, LocalJs, Zones, AdServer, General
	},
	data: () => {
		return {
			tab: null,
			selectedSite: null,
			selectedType: null,
			showAddSiteDialog: false,
			showEditSiteDialog: false,
			showCopySiteDialog: false,
			showDeployLiveDialog: false,
			showSitesList: false,
			device_types: [],
			key: 0,
			finishedTasks: [
				'Seite hinzufügen / bearbeiten / kopieren / löschen',
				'Sitetype hinzufügen / kopieren / löschen',
				'Zone hinzufügen / löschen',
				'Position hinzufügen / bearbeiten / löschen',
				'Änderungen speichern ("Allgemeines", "Ad-Server", "Zonen", "Local.js", "Local.css", "Module", "Notizen", "Blockieren", "Includes")',
				"Domain erstellen / löschen",
				"Include erstellen / bearbeiten / löschen",
			],
			showSaveChangesDialog: false,
			tab_component: null,
			detailsRowHeight: null,
			next: null,
			beforeRouteLeave: false, // bsp. sites -> emergency
			activeComponent: null,
			beforeSiteLeave: false, // bsp. geo -> gala
			beforeSitetypeLeave: false, // bsp. desktop -> mobile
			siteToBeChangedTo: null,
			sitetypeToBeChangedTo: null,
			startSiteInterval: 0,
			siteStatusInterval: null,
			ada,
			reportingLoader: false,
			//apriljoke: false,
		}
	},
	beforeRouteLeave(to, from, next) {
		this.next = next;
		this.beforeRouteLeave = true;
		this.handleChange();
	},
	async mounted() {
		if (localStorage.getItem("adcontrol_april_joke")) {
			localStorage.removeItem("adcontrol_april_joke");
			//localStorage.setItem("adcontrol_april_joke", "true");
			//this.apriljoke = true;
		}
		this.device_types = this.vuexState.device_types;
		if (this.vuexState.selectedSite) {
			this.selectedSite = this.vuexState.selectedSite;
			this.startSiteInterval++;
		}
		if (this.vuexState.selectedType) this.selectedType = this.vuexState.selectedType;
		await Vue.nextTick();
		this.observeHeight()
		this.initShowSitesList();
		this.$root.$on('inactive', this.clearSiteStatusInterval);
	},
	created() {
		window.addEventListener('beforeunload', this.clearSiteStatusInterval)
	},
	beforeDestroy() {
		this.$root.$off('inactive', this.clearSiteStatusInterval);
		window.removeEventListener('beforeunload', this.clearSiteStatusInterval);
	},
	computed: {
		vuexState() {
			return this.$store.state.display;
		},
		sites() {
			let ret = [];
			this.vuexState.sites.forEach((site) => {
				let sitesPublisher = this.vuexState.publisher.find(x => x.PublisherId === site.PublisherId);
				let sitesDeviceTypes = JSON.parse(site.hasTypes);
				if (this.vuexState.selectedPublisher.includes(sitesPublisher) && sitesDeviceTypes.some(r => this.device_types.includes(r))) {
					let tmpSite = JSON.parse(JSON.stringify(site));
					tmpSite.group = sitesPublisher.Name;
					ret.push(tmpSite);
				}
			});
			return ret;
		},
		siteDetails() {
			return this.vuexState.siteDetails;
		},
		tabs() {
			return this.vuexState.siteDetailsTabs;
		},
		buttonContainerWidth() {
			if (this.$vuetify.breakpoint.lgAndUp) {
				return '300px';
			} else {
				return 'auto';
			}
		},
		readOnly() {
			return this.$store.state.readOnly === 1 || this.$store.state.users.role === 'video';
		},
		siteUpdate() {
			return this.vuexState.siteUpdate;
		},
		sitetypeUpdate() {
			return this.vuexState.sitetypeUpdate;
		},
		deployUpdate() {
			return this.$store.state.deploy.deployUpdate;
		},
		activeTab() {
			return this.$store.state.display.activeTab;
		},
		hasNote() {
			return this.siteDetails ? this.siteDetails.Current.Note !== "" : false;
		},
		deployment() {
			return this.siteDetails ? this.siteDetails.Deployment : null;
		},
		vuexStore_selectedType() {
			return this.vuexState.selectedType;
		},
		detailsContentMinHeight() {
			return this.vuexState.detailsContentMinHeight;
		},
		beforeLeave() {
			return (this.beforeRouteLeave || this.beforeSiteLeave || this.beforeSitetypeLeave)
		},
		role() {
			return this.$store.state.users.role;
		},
		localOrStage() {
			return location.host.indexOf('stage') !== -1 || location.host.indexOf('localhost') !== -1;
		},
		blockerMessage() {
			if (this.siteDetails.Current.BlockerMessage) {
				return this.siteDetails.Current.BlockerMessage.replaceAll('\n', '<br>');
			} else {
				return '';
			}
		}
	},
	methods: {
		async fetchSiteDetails() {
			this.fetchSiteStatus();
			if (this.selectedSite) {
				this.$store.commit('updateLoading', {data: true});
				this.$store.commit('display/updateSelectedSite', {data: this.selectedSite});
				await this.$store.dispatch('display/fetchSiteDetails').then(() => {
					this.$store.commit('updateLoading', {data: false});
				});
			}
		},
		async fetchDetails() {
			this.fetchSiteStatus();
			if (this.selectedType) {
				this.$store.commit('display/updateSelectedType', {data: this.selectedType});
				this.$store.commit('updateLoading', {data: true});
				await this.$store.dispatch('display/fetchDetails').then(() => {
					this.$store.commit('updateLoading', {data: false});
				});
			}
		},
		async fetchSiteStatus() {
			if (this.selectedSite && this.$store.state.users.role !== "read") {
				await this.$store.dispatch('display/siteStatus', {
					siteId: this.selectedSite.SiteId,
					type: 'display'
				});
			}
		},
		initShowSitesList() {
			let adcontrol_show_site_config = localStorage.getItem('adcontrol_show_site_config') === 'true';
			if (localStorage.getItem('adcontrol_show_site_config')) {
				this.showSitesList = adcontrol_show_site_config;
			}
		},
		updateSite() {
			this.selectedSite = this.vuexState.selectedSite;
		},
		updateSitetype() {
			this.selectedType = this.vuexState.selectedType;
		},
		updateActiveTab(name) {
			this.$store.commit('display/updateActiveTab', name);
		},
		activateSnackbar(msg, error = false) {
			if (error && this.showSaveChangesDialog) this.showSaveChangesDialog = false;
			this.$root.$emit('snackbar', msg, error ? 'error' : 'success');
		},
		async submit(json, fromSaveChangesDialog = false) {
			if (this.beforeLeave) {
				json = this.activeComponent.getBody();
			} else if (typeof json === "undefined") {
				if (typeof this.tab_component.submit !== "undefined") {
					this.tab_component.submit();
					return;
				} else {
					json = this.tab_component.getBody();
				}
			}
			let data = await this.$store.dispatch('deploy/saveManagement', json);
			if (data.Status) {
				this.activateSnackbar("Erfolgreich gespeichert.");
			} else {
				if (fromSaveChangesDialog)
					this.tab = this.vuexState.siteDetailsTabs.findIndex(x => x.component === this.vuexState.previousTab);
				this.activateSnackbar("Speichern fehlgeschlagen.", true);
			}
			if (this.showSaveChangesDialog) this.showSaveChangesDialog = false;
			this.triggerNext();
		},
		async deployPreview() {
			let data = await this.$store.dispatch('deploy/deployPreview', this.getDeployBody());
			if (data.Status) {
				this.activateSnackbar("Das Deployment auf Preview wurde erfolgreich durchgeführt.");
			} else {
				this.activateSnackbar("Deployment auf Preview fehlgeschlagen.", true);
			}
		},
		async deployLive(body) {
			let json = this.getDeployBody();
			if (this.$store.state.deploy.deployAll === 1) json.deploy_all = [this.$store.state.deploy.deployAll];
			let mergedJson = {...json, ...body};
			let data = await this.$store.dispatch('deploy/deployLive', mergedJson);
			if (data.Status) {
				this.showDeployLiveDialog = false;
				this.activateSnackbar("Das Deployment auf Live wurde erfolgreich durchgeführt.");
			} else {
				this.activateSnackbar("Deployment auf Live fehlgeschlagen.", true);
			}
		},
		getDeployBody() {
			return {
				publisher_id: this.siteDetails.Site.PublisherId,
				site_id: this.siteDetails.Current.SiteId,
				type_id: this.siteDetails.Current.SitetypeId,
			}
		},
		handleValidation(component) {
			if (component && typeof component.dataChanged !== "undefined" && component.dataChanged()) {
				this.submit(component.getBody());
				if (this.showSaveChangesDialog) this.showSaveChangesDialog = false;
			} else {
				this.activateSnackbar('Es wurden keine Änderungen festgestellt.');
			}
			this.triggerNext();
		},
		handleChange(component) {
			if (typeof component !== "undefined") this.tab_component = component;
			let skipTabs = ['Domains', 'History'];
			let tmp_component = this.beforeLeave ? this.activeComponent : this.tab_component;
			if (!skipTabs.includes(tmp_component.$options._componentTag) &&
				(this.$store.state.readOnly === 0 || (this.role === 'native' && this.vuexState.previousTab === 'LocalCss')) &&
				this.selectedSite && tmp_component &&
				typeof tmp_component.dataChanged !== "undefined" &&
				tmp_component.dataChanged() &&
				(this.activeTab !== tmp_component.$options._componentTag || this.beforeLeave)
			) {
				this.showSaveChangesDialog = true;
			} else {
				this.triggerNext();
			}
		},
		triggerChildsInit() {
			let tmp_component = this.beforeLeave ? this.activeComponent : this.tab_component;
			if (typeof tmp_component.init !== "undefined") {
				tmp_component.init();
			}
			if (this.showSaveChangesDialog) this.showSaveChangesDialog = false;
			this.triggerNext();
		},
		openDeployDialog() {
			this.showDeployLiveDialog = true;
		},
		observeHeight() {
			const resizeObserver = new ResizeObserver(() => {
				if (this.$refs.tabContent && this.$refs.tabHeader && this.$refs.tabContent.$el && this.$refs.tabHeader.$el) {
					let calcHeight = this.$refs.tabContent.$el.clientHeight + this.$refs.tabHeader.$el.clientHeight;
					this.detailsRowHeight = calcHeight > this.detailsContentMinHeight ? calcHeight : this.detailsContentMinHeight;
				}
			});
			resizeObserver.observe(this.$refs.tabContent.$el);
		},
		toggleSitesList() {
			this.showSitesList = !this.showSitesList;
			localStorage.setItem('adcontrol_show_site_config', this.showSitesList);
		},
		updateActiveComponent(component) {
			this.activeComponent = component;
		},
		triggerNext() {
			if (this.beforeRouteLeave) {
				this.beforeRouteLeave = false;
				if (this.next) this.next();
				this.clearSiteStatusInterval();
				this.siteStatusInterval = null;
				this.next = null;
			}
			if (this.beforeSiteLeave) {
				this.beforeSiteLeave = false;
				this.selectedSite = this.siteToBeChangedTo;
			}
			if (this.beforeSitetypeLeave) {
				this.beforeSitetypeLeave = false;
				this.selectedType = this.sitetypeToBeChangedTo;
			}
		},
		clearSiteStatusInterval() {
			if (this.siteStatusInterval) {
				clearInterval(this.siteStatusInterval);
			}
		},
		beforeSiteChange($event) {
			this.siteToBeChangedTo = $event;
			this.beforeSiteLeave = true;
			this.handleChange();
		},
		beforeSitetypeChange($event) {
			this.sitetypeToBeChangedTo = $event;
			this.beforeSitetypeLeave = true;
			this.handleChange();
		},
		hideDialogs() {
			if (this.showSaveChangesDialog) {
				this.showSaveChangesDialog = false;
			}
		},
		/*async logDefaultZones() {
				try {
						this.reportingLoader = true;
						let baseUrl = 'https://adcontrol.adalliance.io'
						let copy = JSON.parse(JSON.stringify(this.vuexState.sites));
						copy = copy.filter(x => x.PublisherId !== 3);
						let sites = copy.map((x) => {
								return {
										'SiteId': x.SiteId,
										'Name': x.Name
								}
						})
						for (let i = 0; i < sites.length; i++) {
								/!** for Each Site append Sitetypes as "Sitetypes" **!/
								let config = {headers: {}}
								// eslint-disable-next-line no-undef
								sso.appendHeadersToRequest(function (key, value) {
										config.headers[key] = value;
								});
								//getTypes
								await axios.get(baseUrl + '/api/service.php/management/getTypesAndDetails?local=2&site_id=' + sites[i].SiteId, config)
								.then((res) => {
										let {data} = res;
										let currentSite = sites.find(x => x.SiteId === sites[i].SiteId);
										currentSite.Sitetypes = data.Types.map((x) => {
												return {
														'SitetypeId': x.SitetypeId,
														'Name': x.Name,
												}
										});
										let promises = [];
										currentSite.Sitetypes.forEach((sitetype) => {
												let url = baseUrl + '/api/service.php/management/getDetails?local=2&type_id=' + sitetype.SitetypeId;
												let promise = axios.get(url, config);
												promises.push(promise);
										})
										return Promise.all(promises);
								})
								.then(function (sitetypeDetailRes) {
										sitetypeDetailRes = sitetypeDetailRes.map(x => x.data);
										let promises = [];
										for (let j = 0; j < sitetypeDetailRes.length; j++) {
												let currentSite = sites.find(x => x.SiteId === sitetypeDetailRes[j].Current.SiteId);
												let sitetypeIndex = currentSite.Sitetypes.findIndex(x => x.SitetypeId === sitetypeDetailRes[j].Current.SitetypeId);
												currentSite.Sitetypes[sitetypeIndex].DefaultZone = {};
												let url = baseUrl + '/api/service.php/management/getZoneDetails?local=2&zone_id=' + sitetypeDetailRes[j].Zones.find(x => x.Name === '_default').ZoneId;
												let promise = axios.get(url, config);
												promises.push(promise);
										}
										return Promise.all(promises);
								})
								.then(function (zoneDetailRes) {
										zoneDetailRes = zoneDetailRes.map(x => x.data);
										for (let j = 0; j < zoneDetailRes.length; j++) {
												let currentSite = sites.find(x => x.Sitetypes.map(y => y.SitetypeId).includes(zoneDetailRes[j].Zone.SitetypeId));
												let sitetypeIndex = currentSite.Sitetypes.findIndex(x => x.SitetypeId === zoneDetailRes[j].Zone.SitetypeId);
												currentSite.Sitetypes[sitetypeIndex].DefaultZone.Details = zoneDetailRes[j].Zone;
												Object.keys(zoneDetailRes[j].Position).forEach(function (key) {
														if (typeof zoneDetailRes[j] === "undefined" || typeof zoneDetailRes[j].Position[key] === "undefined" || typeof zoneDetailRes[j].Position[key].Sizes === "undefined") {
																console.log(zoneDetailRes[j]);
														} else {
																zoneDetailRes[j].Position[key] = zoneDetailRes[j].Position[key].Sizes.map(x => x.Type === "Text" ? x.Text : (x.Width + 'x' + x.Height)).join(', ');
														}
												});
												currentSite.Sitetypes[sitetypeIndex].DefaultZone.Position = zoneDetailRes[j].Position;
												//currentSite.Sitetypes[sitetypeIndex].DefaultZone = sitetypeDetailRes[j].Zones.find(x => x.Name === '_default');
										}
								})
								.catch((error) => {
										if (error.response) {
												// Request made and server responded
												console.log(error.response.data);
												console.log(error.response.status);
												console.log(error.response.headers);
										} else if (error.request) {
												// The request was made but no response was received
												console.log(error.request);
										} else {
												// Something happened in setting up the request that triggered an Error
												console.log('Error', error.message);
										}
								})
						}
						this.reportingLoader = false;
						this.$root.$emit('snackbar', 'Reporting wurde erfolgreich gezogen: Bitte in der console in den dev tools anschauen.')
						console.log('sites', sites);
				} catch (e) {
						this.reportingLoader = false;
						this.$root.$emit('snackbar', 'Error: There was an error', 'error')
				}
		}*/
	}
	,
	watch: {
		isUpdating(val) {
			if (val) {
				setTimeout(() => (this.isUpdating = false), 3000)
			}
		},
		tab(newValue) {
			this.updateActiveTab(this.tabs[newValue].component);
		},
		sites() {
			this.key++;
		},
		selectedSite(n, o) {
			if (!this.vuexState.ignoreSiteUpdate && this.selectedSite !== null) {
				this.fetchSiteDetails();
			} else {
				this.key++;
				this.$store.commit('display/updateIgnoreSite', {data: false});
				if (n && o && n.SiteId !== o.SiteId) {
					this.fetchSiteDetails();
				}
			}
		},
		selectedType(n, o) {
			if (!this.vuexState.ignoreTypeUpdate) {
				this.fetchDetails();
			} else {
				this.$store.commit('display/updateIgnoreType', {data: false});
				if (n && o && n.SitetypeId !== o.SitetypeId) {
					this.fetchDetails();
				}
			}
		},
		vuexStore_selectedType() {
			if (this.vuexStore_selectedType === null) {
				this.selectedType = null;
				this.selectedSite = null;
			}
		},
		siteUpdate() {
			this.updateSite();
		},
		sitetypeUpdate() {
			this.updateSitetype();
		},
		deployUpdate() {
			this.updateSite();
			this.updateSitetype();
		},
		device_types() {
			this.$store.commit('display/updateDeviceTypes', this.device_types);
		},
		siteStatusInterval(n, o) {
			if (o && n !== o) {
				clearInterval(o);
			}
		}
	}
}
</script>

<style lang="scss" scoped>


.device_container {
	margin: 0;
}

.site_action_button, .site_edit_button {
	&.lg, &.xl {
		margin-bottom: 15px;
	}

	&.xs, &.sm, &.md {
		margin-right: 15px;
	}
}

.borderTopRadius {
	border-top-left-radius: 4px;
	border-top-right-radius: 4px;
}

.borderBottomRadius {
	border-bottom-left-radius: 4px;
	border-bottom-right-radius: 4px;
}

.siteListToggle {
	position: absolute;
	left: 0;
}

.displayNone {
	display: none;
}

.adaBundle {
	position: absolute;
	right: 4rem;
	width: 210px;
	height: 205px;
	object-fit: contain;
	-webkit-animation-name: pulse;
	animation-name: pulse;
	-webkit-animation-duration: 0.5s;
	animation-duration: 0.5s;
	opacity: 0;
	-webkit-animation-fill-mode: forwards;
	animation-fill-mode: forwards;
}

@-webkit-keyframes pulse {
	0% {
		opacity: 0;
	}
	10% {
		opacity: .50;
		transform-origin: 50% 50%;
		transform: rotate(-2deg) scale(5);
		transition: all .3s cubic-bezier(0.6, 0.04, 0.98, 0.335);
	}
	100% {
		opacity: 1;
		transform: rotate(15deg) scale(1);
	}
}
</style>